import { render, staticRenderFns } from "./IconQuoteEnd.vue?vue&type=template&id=5dc009d9&"
import script from "./IconQuoteEnd.vue?vue&type=script&lang=ts&"
export * from "./IconQuoteEnd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports